module.exports = __webpack_public_path__ + "img/image21.2653d6a6.jpg";